const clientOn = (state = {}, action) => {
    switch (action.type) {
        case "SET_CLIENT":
            return {
                ...state,
                client: action.payload,
            }
        default:
            return state
    }
}

export default clientOn;